import React, { Component } from "react";
import NavBottom from "../../base/features/blocks/NavBottom";
import Spinner from "../../base/features/micro/Spinner";
import { carts } from "./services";
import Empty from "../../base/features/blocks/Empty";
import { MdClose } from "react-icons/md";
import CartsBlock from "../blocks/CartsBlock";

class Carts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carts: null,
    };
  }
  componentDidMount() {
    this.getCarts();
  }

  getCarts() {
    carts().then((items) => {
      items && this.setState({ carts: items.results });
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <NavBottom />
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col align-self-center text-center px-0">
            <h1 className="fs-5 fw-bolder mb-0 text-end">سبد های خرید</h1>
          </div>
          <div className="col-auto align-self-center">
            <MdClose
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
        </header>
        <body style={{ marginTop: "80px", marginBottom: "100px" }}>
          {this.state.carts ? (
            this.state.carts.length === 0 ? (
              <Empty text={"سبد خریدی ثبت نشده است."} />
            ) : (
              this.state.carts.map((cart, c) => <CartsBlock cart={cart} />)
            )
          ) : (
            <Spinner />
          )}
        </body>
      </div>
    );
  }
}

export default Carts;
